/**
 * Botón visual para elegir origen de pedido en /orders/new. Idéntico al
 * del desktop (`apps/desktop/src/renderer/src/pages/orderNew/OriginTile.tsx`).
 */

import { cn } from '@atreus/ui';
import type { ComponentType } from 'react';

interface Props {
  icon: ComponentType<{ className?: string }>;
  label: string;
  description?: string;
  selected: boolean;
  onClick: () => void;
}

export const OriginTile = ({
  icon: Icon,
  label,
  description,
  selected,
  onClick,
}: Props) => (
  <button
    type="button"
    onClick={onClick}
    aria-pressed={selected}
    className={cn(
      'flex flex-col items-start gap-2 rounded-md border p-5 text-left transition-colors',
      selected
        ? 'border-fg bg-fg text-fg-inverse'
        : 'border-border bg-surface text-fg hover:border-fg',
    )}
  >
    <span
      className={cn(
        'flex size-10 items-center justify-center rounded-md',
        selected
          ? 'bg-fg-inverse/10 text-fg-inverse'
          : 'bg-surface-muted text-fg',
      )}
    >
      <Icon className="size-5" />
    </span>
    <div className="text-lg font-black tracking-tight">{label}</div>
    {description ? (
      <div
        className={cn(
          'text-xs',
          selected ? 'text-fg-inverse/70' : 'text-fg-muted',
        )}
      >
        {description}
      </div>
    ) : null}
  </button>
);
